<template>
<div class="rotated-img" ref="rotatedImg" v-on:mousemove="mousePosition">
  <img class="img-fluid" src="@/assets/images/works/img-loading.svg">
  <template v-if="isShown">
    <div class="img-bg-white">
    </div>
    <img v-for="i in 8" :key="i" class="thumbnail" :class="rotationClass(i)" :src="loadSrc(i)" @load="load"/>
  </template>
  <div class="loading d-flex justify-content-center align-items-center" :class="completeLoading? 'fadeout': ''">
    <span class="futura text-white p-relative"><b-spinner label="Spinning" small variant="light" class="mr-3"></b-spinner>NOW LOADING...</span>
  </div>
</div>
</template>

<script>
import isMobile from 'ismobilejs'

export default {
  name: 'RollingImageLg',
  props: {
    directoryNo: {
      type: String,
      default: '1'
    },
    rotationLv: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      isShown: false,
      isMobile,
      loadedCounter: 0,
      completeLoading: false,
      rotationLvPc: 1
    }
  },
  mounted() {
    setTimeout(()=>{
      this.isShown = true
    }, 1000)
  },
  computed: {

  },
  methods: {
    loadSrc(index) {
      if (this.isMobile().phone) {
        return './images/works/'+ this.directoryNo +'/'+ index +'.jpg'
      } else {
        return './images/works/'+ this.directoryNo +'/'+ index +'@2x.jpg'
      }
    },
    rotationClass(index) {
      if (this.isMobile().any) {
        return this.rotationLv == index? '': 'opacity-0'
      } else {
        return this.rotationLvPc == index? '': 'opacity-0'
      }
    },
    load() {
      this.loadedCounter++
      if(this.loadedCounter >= 8) {
        this.completeLoading = true
        this.$emit('loaded')
      }
    },
    mousePosition: function(event) {
      if (this.isMobile().any) {
        return
      }
      const w = this.$refs.rotatedImg.clientWidth
      const x = event.offsetX
      this.rotationLvPc = Math.floor(x / w * 8.0) + 1
      if (this.rotationLvPc > 8) {
        this.rotationLvPc = 8
      } else if (this.rotationLvPc < 1) {
        this.rotationLvPc = 1
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.rotated-img {
  position: relative;
  .img-bg-white {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .thumbnail {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    transition: opacity 0.05s;
    opacity: 1;
    &.opacity-0 {
      opacity: 0;
    }
  }
  .loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background-color: #333;
      transition: width 0.6s;
    }
    &.fadeout {
      pointer-events: none;
      &:before {
        width: 0%;
        pointer-events: none;
      }
      > span {
        display: none;
      }
    }
  }
}
</style>